import Option from './Option';
import { Container } from './styles';
import { SelectableTileProps } from './types';

const SelectableTile = (props: SelectableTileProps) => {
  return (
    <Container disabled={props.disabled} {...props}>
      {props.children}
    </Container>
  );
};

SelectableTile.Option = Option;

export default SelectableTile;
